import React from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "../../utils/cn";

type AccordionProps = {
  title: string;
  component?: React.ReactNode;
  children?: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
  contentClassName?: string;
};

const Accordion: React.FC<AccordionProps> = ({
  title,
  component,
  children,
  defaultOpen = false,
  className,
  contentClassName,
}) => {
  const [isOpen, setIsOpen] = React.useState(defaultOpen);
  const contentId = React.useId();
  const body = component ?? children;

  return (
    <div
      className={cn("rounded-lg border border-gray-200 bg-white", className)}
    >
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
        aria-controls={contentId}
        className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
      >
        <span className="text-md font-semibold text-gray-900">{title}</span>
        <ChevronDown
          className={cn(
            "h-4 w-4 text-gray-500 transition-transform duration-200",
            isOpen && "rotate-180"
          )}
        />
      </button>
      <div
        id={contentId}
        role="region"
        className={cn("px-4 pb-4", !isOpen && "hidden", contentClassName)}
      >
        {body}
      </div>
    </div>
  );
};

export default Accordion;
